/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { Status } from "../models/index";
import { StatusFromJSON, StatusToJSON } from "../models/index";

/**
 *
 */
export class StatusApi extends runtime.BaseAPI {
  /**
   */
  async statusRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Status>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/api/status/`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => StatusFromJSON(jsonValue));
  }

  /**
   */
  async statusRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Status> {
    const response = await this.statusRetrieveRaw(initOverrides);
    return await response.value();
  }
}
